import { createAction, handleActions } from 'redux-actions';
import api from 'api';

/* 액션 생성 */
const ADD_POPUP_CNT = 'base/ADD_POPUP_CNT';
const SUB_POPUP_CNT = 'base/SUB_POPUP_CNT';

const SET_TOAST_CURRENT = 'base/SET_TOAST_CURRENT';
const SET_TOAST_QUEUE = 'base/SET_TOAST_QUEUE';

const SET_USING_QNA = 'base/SET_USING_QNA';


export const addPopupCnt = createAction(ADD_POPUP_CNT);
export const subPopupCnt = createAction(SUB_POPUP_CNT);


const toastDuration = 3000;
const toastInterval = 500;

const setCurrentToast = (toastBody, dispatch) => {
  return new Promise(resolve => {
    dispatch({ type: SET_TOAST_CURRENT, payload: toastBody });
    if (!toastBody) {
      return;
    }
    setTimeout(() => {
      dispatch({ type: SET_TOAST_CURRENT, payload: null });
      resolve();
    }, toastDuration);
  });
}
const addToastQueue = async (toastBody, dispatch, getState) => {
  let list = [...getState().base.toast.queue, toastBody];
  dispatch({ type: SET_TOAST_QUEUE, payload: list });
}
const nextToastQueue = async (dispatch, getState) => {
  let list = [...getState().base.toast.queue];
  const toastBody = list.shift();
  
  await setCurrentToast(toastBody, dispatch)

  if (!toastBody) {
    return;
  }
  dispatch({ type: SET_TOAST_QUEUE, payload: list });
  
  setTimeout(() => {
    nextToastQueue(dispatch, getState);
  }, toastInterval);

}

export const showToast = params => async (dispatch, getState) => {
  const currentToast = getState().base.toast.current;
  const queue = getState().base.toast.queue;
  if (currentToast || queue.length > 0) {
    addToastQueue(params, dispatch, getState);
    return;
  }

  //dispatch({ type: SET_TOAST_CURRENT, payload: params });
  await setCurrentToast(params, dispatch);
  setTimeout(() => {
    nextToastQueue(dispatch, getState);
  }, toastInterval);
}


/**
 * Q&A 사용여부 가져오기
 */
 export const getUsingQna = () => async (dispatch, getState) => {
  try {
    const responseData = await api.base.isUsingMoemeLiteQna();
    dispatch({ type: SET_USING_QNA, payload: responseData.isUsingQna });
  } catch(e) {
    console.log(e)
  }

}



/* 초기상태 설정(immutable) */
const initialState = {
    popupCnt: 0,
    toast: {
      current: null,
      queue: [],
    },
    isUsingQna: false,
};

/* 리듀서 정의 */
export default handleActions({
  [ADD_POPUP_CNT]: (state, action) => {
    const cnt = state.popupCnt;
    document.documentElement.classList.add('hold');

    return ({
      ...state, 
      popupCnt: cnt+1,
    })
  },
  [SUB_POPUP_CNT]: (state, action) => {
    const cnt = state.popupCnt;
    if (cnt <= 1) {
      document.documentElement.classList.remove('hold');
    }
    if (cnt < 1) {
      return state;
    }
    return ({
      ...state, 
      popupCnt: cnt-1,
    })
  },
  [SET_TOAST_CURRENT]: (state, action) => {
    const toastBody = action.payload;
    return {
      ...state,
      toast: {
        ...state.toast,
        current: toastBody,
      }
    };
  },
  [SET_TOAST_QUEUE]: (state, action) => {
    const toastQueue = action.payload;
    return {
      ...state,
      toast: {
        ...state.toast,
        queue: toastQueue,
      }
    };
  },
  [SET_USING_QNA]: (state, action) => {
    const usingQna = action.payload;
    return {
      ...state,
      isUsingQna: usingQna,
    };
  },
}, initialState)